import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";

const EnquiryMenu = (props) => {
  const { t, handleNavItemClick, activeLink, handleContextMenu } = props;
  const params = useParams();

  return (
    <div className="sub-list">
      <ul>
        <li
          data-link={`/request/list/to-process`}
          onClick={handleNavItemClick}
          onContextMenu={handleContextMenu}
          className={activeLink === "/request/list/to-process" ? "active" : ""}
        >
          {t("MENU_ENQUIRIES_TO_PROCESS")}
        </li>
        <li
          data-link={`/request/list/transport-quotation`}
          onClick={handleNavItemClick}
          onContextMenu={handleContextMenu}
          className={
            activeLink === "/request/list/transport-quotation" ? "active" : ""
          }
        >
          {t("MENU_ENQUIRIES_TRANSPORT_QUOTATION")}
        </li>
      </ul>
    </div>
  );
};

EnquiryMenu.propTypes = {
  t: PropTypes.func.isRequired,
  handleNavItemClick: PropTypes.func.isRequired,
  handleContextMenu: PropTypes.func.isRequired,
};

export default withTranslation()(EnquiryMenu);
